import React from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeUiLang, persistManualLanguage } from '../utils/localePreference';

const LANG_OPTIONS = [
  { code: 'en', labelKey: 'home_lang_en', flag: '🇬🇧' },
  { code: 'sw', labelKey: 'home_lang_sw', flag: '🇹🇿' },
  { code: 'fr', labelKey: 'home_lang_fr', flag: '🇫🇷' },
] as const;

interface LanguageSwitcherProps {
  className?: string;
  compact?: boolean;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className = '', compact }) => {
  const { t, i18n } = useTranslation();
  const resolvedLang = normalizeUiLang(i18n.resolvedLanguage || i18n.language);

  return (
    <select
      value={resolvedLang}
      onChange={(e) => {
        persistManualLanguage(e.target.value);
        void i18n.changeLanguage(e.target.value);
      }}
      aria-label={t('home_lang_select')}
      className={
        compact
          ? `text-sm border border-gray-200 rounded-lg px-2 py-1.5 bg-white text-gray-800 cursor-pointer ${className}`
          : `text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-800 cursor-pointer focus:ring-2 focus:ring-blue-500 ${className}`
      }
    >
      {LANG_OPTIONS.map((l) => (
        <option key={l.code} value={l.code}>
          {l.flag} {t(l.labelKey)}
        </option>
      ))}
    </select>
  );
};
